/* eslint-disable */
import { Media } from './common';
import { AppEmbedData_AppType } from './plugin_app_embed.enums';
export function appEmbedData_AppTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'PRODUCT':
            return AppEmbedData_AppType.PRODUCT;
        case 1:
        case 'EVENT':
            return AppEmbedData_AppType.EVENT;
        case 2:
        case 'BOOKING':
            return AppEmbedData_AppType.BOOKING;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return AppEmbedData_AppType.UNRECOGNIZED;
    }
}
export function appEmbedData_AppTypeToJSON(object) {
    switch (object) {
        case AppEmbedData_AppType.PRODUCT:
            return 'PRODUCT';
        case AppEmbedData_AppType.EVENT:
            return 'EVENT';
        case AppEmbedData_AppType.BOOKING:
            return 'BOOKING';
        default:
            return 'UNKNOWN';
    }
}
const baseAppEmbedData = { type: AppEmbedData_AppType.PRODUCT };
export const AppEmbedData = {
    fromJSON(object) {
        const message = Object.assign({}, baseAppEmbedData);
        message.type =
            object.type !== undefined && object.type !== null
                ? appEmbedData_AppTypeFromJSON(object.type)
                : AppEmbedData_AppType.PRODUCT;
        message.itemId =
            object.itemId !== undefined && object.itemId !== null ? String(object.itemId) : undefined;
        message.name =
            object.name !== undefined && object.name !== null ? String(object.name) : undefined;
        message.imageSrc =
            object.imageSrc !== undefined && object.imageSrc !== null
                ? String(object.imageSrc)
                : undefined;
        message.url = object.url !== undefined && object.url !== null ? String(object.url) : undefined;
        message.image =
            object.image !== undefined && object.image !== null
                ? Media.fromJSON(object.image)
                : undefined;
        message.bookingData =
            object.bookingData !== undefined && object.bookingData !== null
                ? AppEmbedData_BookingData.fromJSON(object.bookingData)
                : undefined;
        message.eventData =
            object.eventData !== undefined && object.eventData !== null
                ? AppEmbedData_EventData.fromJSON(object.eventData)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = appEmbedData_AppTypeToJSON(message.type));
        message.itemId !== undefined && (obj.itemId = message.itemId);
        message.name !== undefined && (obj.name = message.name);
        message.imageSrc !== undefined && (obj.imageSrc = message.imageSrc);
        message.url !== undefined && (obj.url = message.url);
        message.image !== undefined &&
            (obj.image = message.image ? Media.toJSON(message.image) : undefined);
        message.bookingData !== undefined &&
            (obj.bookingData = message.bookingData
                ? AppEmbedData_BookingData.toJSON(message.bookingData)
                : undefined);
        message.eventData !== undefined &&
            (obj.eventData = message.eventData
                ? AppEmbedData_EventData.toJSON(message.eventData)
                : undefined);
        return obj;
    },
};
const baseAppEmbedData_BookingData = {};
export const AppEmbedData_BookingData = {
    fromJSON(object) {
        const message = Object.assign({}, baseAppEmbedData_BookingData);
        message.durations =
            object.durations !== undefined && object.durations !== null
                ? String(object.durations)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.durations !== undefined && (obj.durations = message.durations);
        return obj;
    },
};
const baseAppEmbedData_EventData = {};
export const AppEmbedData_EventData = {
    fromJSON(object) {
        const message = Object.assign({}, baseAppEmbedData_EventData);
        message.scheduling =
            object.scheduling !== undefined && object.scheduling !== null
                ? String(object.scheduling)
                : undefined;
        message.location =
            object.location !== undefined && object.location !== null
                ? String(object.location)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.scheduling !== undefined && (obj.scheduling = message.scheduling);
        message.location !== undefined && (obj.location = message.location);
        return obj;
    },
};
//# sourceMappingURL=plugin_app_embed.js.map